<template>
  <div class="imgUpload">
    <el-tabs v-model="activeName" @tab-click="handle_click">
      <el-tab-pane label="我的图片" name="myImg">
        <!-- 顶部检索 -->
        <el-row>
          <el-col :span="24" class="head-btn">
            <el-form ref="searchform" :inline="true">
              <!-- 图片名称的检索 -->
              <el-form-item>
                <el-input
                  v-model.trim="searchForm.img_name"
                  maxlength="20"
                  placeholder="请输入搜索内容"
                  size="mini"
                  style="display: inline-block"
                  suffix-icon="el-icon-search"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="mini" type="primary" @click="search_btn()"
                >搜索
                </el-button
                >
                <el-button size="mini" @click="reset_btn()">重置</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!-- 内容区 -->
        <el-row>
          <!-- 左侧 -->
          <el-col :span="6">
            <!-- 左侧上部分分组区,展示区 -->
            <div class="leftList">
              <div
                v-for="item in categoryList"
                :key="item.id"
                class="category-items"
              >
                <div
                  :class="categoryId == item.id ? 'category-item-bgc' : ''"
                  class="category-item"
                  @click="click_category(item)"
                >
                  <p>{{ item.category_name }}</p>
                </div>
              </div>
            </div>
            <!-- 左侧下部分按钮区 -->
            <el-form :inline="true">
              <!-- 左侧下部分添加分组区 -->
              <el-form-item>
                <el-popover
                  v-model="addCategoryShow"
                  placement="top"
                  title="分组名称"
                  trigger="click"
                  width="280"
                >
                  <el-form
                    key="categoryForm"
                    ref="categoryForm"
                    :model="categoryForm"
                    :rules="rules"
                    label-position="top"
                    status-icon
                  >
                    <el-form-item prop="category_name">
                      <el-input
                        v-model.trim="categoryForm.category_name"
                        maxlength="15"
                        placeholder="请输入1-15个字符"
                        size="mini"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        size="mini"
                        type="primary"
                        @click="submit_category_btn('categoryForm')"
                      >确定
                      </el-button
                      >

                      <el-button
                        size="mini"
                        v-on:click="addCategoryShow = false"
                      >取消
                      </el-button
                      >
                    </el-form-item>
                  </el-form>
                  <el-button slot="reference" class="floor-add-btn" size="mini"
                  >新增分组
                  </el-button
                  >
                </el-popover>
              </el-form-item>
              <!-- 修改分类的弹层 -->
              <el-form-item>
                <el-popover
                  v-show="categoryPower"
                  v-model="updateCategoryShow"
                  placement="top"
                  title="编辑分组"
                  trigger="click"
                  width="280"
                  @show="update_show"
                >
                  <el-form
                    ref="categoryForm"
                    :model="categoryForm"
                    :rules="rules"
                    label-position="top"
                    status-icon
                  >
                    <el-form-item prop="category_name">
                      <el-input
                        v-model.trim="categoryForm.category_name"
                        maxlength="15"
                        placeholder="请输入1-15个字符"
                        size="mini"
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        size="mini"
                        type="primary"
                        @click="submit_category_btn('categoryForm')"
                      >确定
                      </el-button
                      >

                      <el-button
                        size="mini"
                        v-on:click="updateCategoryShow = false"
                      >取消
                      </el-button
                      >
                    </el-form-item>
                  </el-form>
                  <el-button slot="reference" class="floor-add-btn" size="mini"
                  >编辑分组
                  </el-button
                  >
                </el-popover>
              </el-form-item>
              <!-- 删除分类按钮 -->
              <el-form-item>
                <el-button
                  v-if="categoryPower"
                  class="floor-add-btn"
                  size="mini"
                  @click="delete_category_btn"
                >删除
                </el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <!-- 右侧  offset 偏移属性-->
          <el-col :offset="1" :span="17">
            <!-- 右侧 上部分图片展示区 -->
            <div class="img-box">
              <!-- 图片展示区的多选按钮 -->
              <div class="img-box-header">
                <div v-if="type == '3'" class="checkbox">
                  <el-checkbox
                    v-model="checkAll"
                    :indeterminate="isIndeterminate"
                    @change="checked_img_all"
                  >全选
                  </el-checkbox
                  >
                </div>
              </div>
              <!-- 图片展示区的中间部分展示 -->
              <el-checkbox-group
                v-model="checkedImageIds"
                @change="checked_img"
              >
                <div class="img-box-middle">
                  <div class="img-box-items">
                    <div v-for="item in imgTableList"
                         :key="item.id"
                         class="img-item">
                      <el-popover placement="top-start"
                                  trigger="click">
                        <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="item.img_path_url"
                           target="_blank"
                           title="查看最大化图片">
                          <img :src="item.img_path_url"
                               style="width: 300px; height: 200px; object-fit: cover"/>
                        </a>
                        <img slot="reference"
                             :src="item.img_path_url"
                             alt="加载失败~"
                             onerror="this.src='https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'">
                      </el-popover>
                      <div class="img-item-floor">
                        <div class="img-checkbox">
                          <!-- 选择框 -->
                          <el-checkbox :label="item.id">{{
                              item.item
                            }}
                          </el-checkbox>
                        </div>
                        <!-- 图片标题 -->
                        <div class="img-title">
                          {{ item.img_name }}
                        </div>
                      </div>
                    </div>
                    <div v-for="i in 7" :key="i" class="temp"></div>
                  </div>
                </div>
              </el-checkbox-group>
            </div>
            <!-- 右侧 底部按钮 -->
            <el-row>
              <!-- 修改分组和删除图片按钮 -->
              <el-col v-if="checkedImageIds.length > 0" :span="6">
                <el-form :inline="true">
                  <!-- 修改分类的弹层 -->
                  <el-form-item>
                    <el-popover
                      v-model="updateImgCategoryShow"
                      placement="top"
                      title="修改分组"
                      trigger="click"
                      width="280"
                      @show="update_show"
                    >
                      <el-form
                        ref="categoryForm"
                        :model="categoryForm"
                        :rules="rules"
                        label-position="top"
                        status-icon
                      >
                        <el-form-item>
                          <el-select
                            v-model="updateImgCategoryId"
                            class="select-width"
                            placeholder="请选择"
                            size="mini"
                          >
                            <el-option
                              v-for="item in categoryList"
                              :key="item.id"
                              :label="item.category_name"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="updateImgCategoryId">
                          <el-button
                            size="mini"
                            type="primary"
                            @click="submit_img_category_btn('categoryForm')"
                          >确定
                          </el-button
                          >

                          <el-button
                            size="mini"
                            v-on:click="updateImgCategoryShow = false"
                          >取消
                          </el-button
                          >
                        </el-form-item>
                      </el-form>
                      <el-button
                        slot="reference"
                        class="floor-add-btn"
                        size="mini"
                      >修改分组
                      </el-button
                      >
                    </el-popover>
                  </el-form-item>
                  <!-- 删除分类按钮 -->
                  <el-form-item>
                    <el-button
                      class="floor-add-btn"
                      size="mini"
                      @click="delete_img_btn"
                    >删除
                    </el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
              <!-- 页码 -->
              <el-col :offset="checkedImageIds.length > 0 ? 0 : 5" :span="18">
                <my-pages
                  :currentPage="searchForm.pageNum"
                  :pageSize="searchForm.pageSize"
                  :pageSizes="[14, 42, 84, 100]"
                  :total="searchForm.totals"
                  class="pagination"
                  @currentChange="change_current_btn"
                  @sizeChange="change_size_btn"
                ></my-pages>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- 上传图片 -->
      <el-tab-pane label="上传图片" name="upload">
        <div class="imgContent">
          <el-form
            ref="addImageForm"
            :model="addImageForm"
            :rules="rules"
            class="demo-ruleForm"
            label-width="100px"
            size="mini"
            style="margin: 20px 0px 0px 20px"
          >
            <!-- 选择分组 -->
            <el-form-item key="category_id" label="选择分组" prop="category_id">
              <el-col :span="8">
                <el-select
                  v-model="addImageForm.category_id"
                  class="select-width"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in categoryList"
                    :key="item.id"
                    :label="item.category_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <!-- 本地图片 -->
            <el-form-item ref="photo" label="本地图片" prop="photo">
              <el-upload
                :before-upload="before_avatar_upload"
                :class="{'avatar-uploader': true , 'hide_preview': noPreview}"
                :file-list="addImageUrlList"
                :http-request="upload_img_url"
                :limit="25"
                :on-preview="img_preview_btn"
                :on-remove="img_remove_btn"
                action="#"
                list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div style="color: #ccc">
                一次性最多添加25张JPG/PNG格式的图片,每张图片最大为200K
              </div>
              <!-- 图片预览的弹窗 -->
              <el-dialog
                :close-on-click-modal="true"
                :visible.sync="dialogVisible"
                class="dialog-br"
                style="text-align: center"
                title="图片预览"
                width="fit-content"
              >
                <img :src="imageUrl" alt width="500px"/>
              </el-dialog>
            </el-form-item>

            <!-- 上传图片 按钮 -->
            <el-form-item>
              <el-button
                size="mini"
                type="primary"
                @click="submit_img_btn('addImageForm')"
              >确定
              </el-button
              >
              <el-button size="mini" @click='clear_img_form()'
              >取消
              </el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div v-if="type != 3" class="btm_btn">
      <el-button size="mini" v-on:click="close_checked_img()">取消</el-button>
      <el-button size="mini" type="primary" @click="submit_checked_img()"
      >保存
      </el-button
      >
    </div>
  </div>
</template>
<script>
import index from "./material.js";

export default {
  ...index,
};
</script>
<style lang="less" scoped>
@import url("./material.less");

</style>
<style>
.hide_preview .el-upload-list__item-preview {
  display: none !important;;
}
</style>
